import { useEffect, useState } from 'react';

function useAdBlockerCheck() {
  const [isAdBlockerEnabled, setIsAdBlockerEnabled] = useState(false);

  useEffect(() => {
    const checkAdBlocker = () => {
      // Create a script element that points to a known ad-related URL
      const script = document.createElement('script');
      script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'; // Common Google Ads script
      script.async = true;

      // If the script fails to load, an ad blocker is likely enabled
      script.onerror = () => setIsAdBlockerEnabled(true);

      // If the script loads successfully, ad blocker is not enabled
      script.onload = () => setIsAdBlockerEnabled(false);

      document.body.appendChild(script);

      // Cleanup the script tag after checking
      return () => {
        document.body.removeChild(script);
      };
    };

    checkAdBlocker();
  }, []);

  return isAdBlockerEnabled;
}

export default useAdBlockerCheck;
